import { IncomingMessage } from 'http';
import urlsService from './urls-service';
import type * as Types from '@/pages/mijn-carel-lurvink/catalogus/stores/types';

export class NavigationService {
  categories: any;
  sector: AppSector;

  constructor(categories: Types.Category[] = [], sector = 'facility') {
    this.categories = categories ?? [];
    this.sector = sector as AppSector;
  }

  transformResponse(categories: Types.Category[]) {
    const nextCategories = categories.map((category) => {
      const childCodes = category.childCodes.map((childCode) => childCode.toString());
      return {
        ...category,
        urlSet: {
          ...category.urlSet
        },
        childCodes,
        ...(category?.parentCode ? { parentCode: category.parentCode.toString() } : {})
      };
    });

    return nextCategories;
  }

  async fetchNavigationData(req: IncomingMessage | undefined) {
    const params = new URLSearchParams();
    params.set('sector', this.sector);
    params.set('depth', '20');

    try {
      const cookieHeader = req?.headers.cookie || '';
      const url = urlsService.getUrl(`categories?${params.toString()}`);
      const response = await fetch(url, {
        next: { revalidate: 900 }, // Cache for 15 minutes
        headers: {
          cookie: cookieHeader
        }
      });
      const data = await response.json();
      const transformedCategories = this.transformResponse(data);
      this.categories = transformedCategories;
    } catch (e) {
      //TODO log error with application insights
      console.error('Error getting navigation data: ', e);
      this.categories = [];
    }
  }

  setSector(sector: AppSector) {
    this.sector = sector;
  }

  setCategories(categories: Types.Category[]): void {
    this.categories = categories;
  }

  getAllCategories(): Types.Category[] {
    return this.categories;
  }

  getRootCategories(): Types.Category[] {
    return this.categories.filter((category: Types.Category) => category.isRoot === true);
  }

  getCategoryByCode(code: string): Types.Category {
    return this.categories?.find((cat: Types.Category) => cat?.code === code);
  }

  getCategoryByParentCode(code: string): Types.Category {
    return this.categories?.find((cat: Types.Category) => cat?.parentCode === code);
  }

  getChildCategoriesByParentCode(parentCode: string) {
    return this.categories.filter((category: Types.Category) => category.parentCode === parentCode);
  }

  getChildCategoriesByChildCodes(childCodes: string[]) {
    const childCategories = this.categories?.filter((category: Types.Category) => {
      return childCodes.some((childCode) => {
        return category.code === childCode;
      });
    });

    return childCategories;
  }
}

const instance = new NavigationService();
export default instance;
